import request from "./request";

//添加信息
export function addContactUs(data) {
  return request({
    url: "/portal/addContactUs",
    method: "post",
	data
  });
}